import { FILL_EMPTY_ONLY_OPTION_VAL } from '../../constants';
export function useSmartFillCalculations({
  fillOption,
  selectedProperties,
  totalRecordCount,
  totalWithEmptyProperties
}) {
  const isFillEmptyOnly = fillOption === FILL_EMPTY_ONLY_OPTION_VAL;
  const getRecordsToFill = () => {
    if (isFillEmptyOnly) {
      return totalWithEmptyProperties || totalRecordCount;
    }
    return totalRecordCount;
  };
  const recordsToFill = getRecordsToFill();
  const estimatedTotal = selectedProperties.length * recordsToFill;
  return {
    recordsToFill,
    estimatedTotal
  };
}